import { pluralize } from "../pluralize";

export const HIDDEN_LABEL_MARKER = "{{H}}";

export interface DefaultTextFrequency {
  interval: string;
  intervalCount: number;
}

const INTERVAL_WORDS: Record<string, { adverb: string; unit: string }> = {
  DAY: { adverb: "daily", unit: "day" },
  WEEK: { adverb: "weekly", unit: "week" },
  MONTH: { adverb: "monthly", unit: "month" },
  YEAR: { adverb: "yearly", unit: "year" },
};

function wordsForInterval(interval: string): { adverb: string; unit: string } {
  if (!Object.prototype.hasOwnProperty.call(INTERVAL_WORDS, interval)) {
    throw new Error(`Unsupported selling plan interval: ${interval}`);
  }
  return INTERVAL_WORDS[interval];
}

function describeDelivery(delivery: DefaultTextFrequency): string {
  const { adverb, unit } = wordsForInterval(delivery.interval);
  return delivery.intervalCount === 1 ? adverb : `every ${pluralize(delivery.intervalCount, unit)}`;
}

/**
 * Builds the storefront text for a plan, for example "Delivered weekly" or
 * "Delivered monthly, pay every 3 months".
 */
export function generateDefaultText(delivery: DefaultTextFrequency, billing: DefaultTextFrequency): string {
  const delivered = `Delivered ${describeDelivery(delivery)}`;

  if (billing.intervalCount === delivery.intervalCount) {
    return delivered;
  }

  const { unit } = wordsForInterval(billing.interval);
  return `${delivered}, pay every ${pluralize(billing.intervalCount, unit)}`;
}

/**
 * The label the storefront shows for a plan. A custom label containing the
 * hidden marker always wins so hidden plans stay hidden.
 */
export function resolveDisplayLabel(
  customLabel: string,
  defaultText: string | null,
  useDefaultText: boolean
): string {
  if (useDefaultText !== true || typeof defaultText !== "string" || customLabel.includes(HIDDEN_LABEL_MARKER)) {
    return customLabel;
  }
  return defaultText;
}
